import { Tracker } from 'usage-tracker-core';
import { LockedTrackerInstance } from 'usage-tracker-core/trackerTypes';
import events from '../../events.yaml';

export const cloneTracker = (
  trackerInstance: Tracker,
  usageTrackerLocation?: string
): Tracker => {
  return trackerInstance.clone({
    events,
    standalone: false,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation,
    },
  });
};

export const cloneStandaloneTracker = (
  trackerInstance: Tracker,
  usageTrackerLocation?: string
): LockedTrackerInstance<{ standalone: true }> => {
  return trackerInstance.clone({
    standalone: true,
    preserveTrackerProperties: false,
    trackerName: 'ai-components-ui-library',
    properties: {
      screen: usageTrackerLocation,
    },
  });
};
